// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/activity/skill_requirements.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/activity/skill_requirements.proto.
 */
export const file_proto_model_booking_activity_skill_requirements = /*@__PURE__*/
  fileDesc("CjVwcm90by9tb2RlbC9ib29raW5nL2FjdGl2aXR5L3NraWxsX3JlcXVpcmVtZW50cy5wcm90bxIGY2FybWVuKskBCgpTa2lsbExldmVsEhsKF1NLSUxMX0xFVkVMX1VOU1BFQ0lGSUVEEAASGAoUU0tJTExfTEVWRUxfQkVHSU5ORVIQARIWChJTS0lMTF9MRVZFTF9OT1ZJQ0UQAhIcChhTS0lMTF9MRVZFTF9JTlRFUk1FRElBVEUQAxIYChRTS0lMTF9MRVZFTF9BRFZBTkNFRBAEEhYKElNLSUxMX0xFVkVMX0VYUEVSVBAFEhwKGFNLSUxMX0xFVkVMX1BST0ZFU1NJT05BTBAGKqwBCgxGaXRuZXNzTGV2ZWwSHQoZRklUTkVTU19MRVZFTF9VTlNQRUNJRklFRBAAEhUKEUZJVE5FU1NfTEVWRUxfTE9XEAESFwoTRklUTkVTU19MRVZFTF9MSUdIVBACEhoKFkZJVE5FU1NfTEVWRUxfTU9ERVJBVEUQAxIWChJGSVRORVNTX0xFVkVMX0hJR0gQBBIZChVGSVRORVNTX0xFVkVMX0VYVFJFTUUQBUIwWi5naXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9ib29raW5nYgZwcm90bzM");

/**
 * Describes the enum carmen.SkillLevel.
 */
export const SkillLevelSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_skill_requirements, 0);

/**
 * Skill level for activities requiring experience
 *
 * @generated from enum carmen.SkillLevel
 */
export const SkillLevel = /*@__PURE__*/
  tsEnum(SkillLevelSchema);

/**
 * Describes the enum carmen.FitnessLevel.
 */
export const FitnessLevelSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_skill_requirements, 1);

/**
 * Physical fitness requirements
 *
 * @generated from enum carmen.FitnessLevel
 */
export const FitnessLevel = /*@__PURE__*/
  tsEnum(FitnessLevelSchema);

